import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × OFFICINE UNIVERSELLE BULY: 19th-century ornament translated into structured abstraction
// Engraved lines, label geometry, sepia grids
export function VasarelyBulyMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="buly-sepia" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F4E8D8" />
          <stop offset="50%" stopColor="#D8C8B0" />
          <stop offset="100%" stopColor="#C0A888" />
        </linearGradient>
        <pattern id="buly-engraving" x="0" y="0" width="2" height="2" patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="2" y2="2" stroke="#8B7355" strokeWidth="0.3" opacity="0.3" />
        </pattern>
      </defs>

      {/* Sepia heritage background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#buly-sepia)" />
      <rect x="0" y="0" width="794" height="1123" fill="url(#buly-engraving)" />

      <g transform="translate(397 540)">
        {/* Sepia grids */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 6.5) * 54;
            const y = (j - 9.5) * 54;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 25}
                y={y - 25}
                width="50"
                height="50"
                fill="none"
                stroke="#8B7355"
                strokeWidth="0.5"
                opacity="0.3"
              />
            );
          })
        )}

        {/* Engraved lines (ornamental) */}
        {Array.from({ length: 30 }).map((_, i) => {
          const y = -450 + i * 30;
          return (
            <line
              key={`h-${i}`}
              x1="-350"
              y1={y}
              x2="350"
              y2={y}
              stroke="#8B7355"
              strokeWidth="0.5"
              opacity="0.25"
            />
          );
        })}

        {Array.from({ length: 26 }).map((_, i) => {
          const x = -350 + i * 27;
          return (
            <line
              key={`v-${i}`}
              x1={x}
              y1="-450"
              x2={x}
              y2="450"
              stroke="#8B7355"
              strokeWidth="0.5"
              opacity="0.25"
            />
          );
        })}

        {/* Label geometry (19th century) */}
        {[
          { x: -180, y: -200, text: "HUILE" },
          { x: -180, y: -100, text: "SAVON" },
          { x: -180, y: 0, text: "PARFUM" },
          { x: -180, y: 100, text: "BAUME" },
          { x: -180, y: 200, text: "EAU" },
        ].map((label, i) => (
          <g key={i}>
            <rect
              x={label.x}
              y={label.y - 25}
              width="140"
              height="50"
              fill="none"
              stroke="#8B7355"
              strokeWidth="2"
              opacity="0.4"
            />
            <rect
              x={label.x + 5}
              y={label.y - 20}
              width="130"
              height="40"
              fill="none"
              stroke="#C0A888"
              strokeWidth="1"
              opacity="0.3"
            />
            <text
              x={label.x + 70}
              y={label.y + 5}
              fontFamily="serif"
              fontSize="16"
              fill="#8B7355"
              textAnchor="middle"
              fontWeight="300"
              letterSpacing="3"
            >
              {label.text}
            </text>
          </g>
        ))}

        {/* Heritage ornament circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 60 + i * 22;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#8B7355"
              strokeWidth="1"
              opacity={0.35 - i * 0.025}
              strokeDasharray="3 3"
            />
          );
        })}

        {/* Central ornamental medallion */}
        <circle cx="0" cy="0" r="100" fill="none" stroke="#8B7355" strokeWidth="3" opacity="0.4" />
        <circle cx="0" cy="0" r="90" fill="none" stroke="#C0A888" strokeWidth="2" opacity="0.3" />
        <circle cx="0" cy="0" r="80" fill="none" stroke="#8B7355" strokeWidth="1" opacity="0.4" />
        
        {/* Ornamental points */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 95;
          
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="5"
              fill="#8B7355"
              opacity="0.5"
            />
          );
        })}

        {/* Center seal */}
        <text
          x="0"
          y="-10"
          fontFamily="serif"
          fontSize="24"
          fill="#8B7355"
          textAnchor="middle"
          fontWeight="300"
          letterSpacing="4"
        >
          BULY
        </text>
        <text
          x="0"
          y="15"
          fontFamily="serif"
          fontSize="12"
          fill="#8B7355"
          textAnchor="middle"
          fontWeight="300"
          letterSpacing="2"
        >
          1803
        </text>
      </g>

      {/* Heritage abstraction */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="9" fill="#8B7355" letterSpacing="2" fontStyle="italic">
        ornement structuré
      </text>
    </g>
  );
}
